<template>
  <b-card-group id="subscription-downgrade-card" deck class="mx-lg-2 h-100" v-if="subscriptionProduct">
    <b-card
      :class="`paid-subs-info-card mb-0 sub-card mx-1 ${isNewPlan ? 'new' : 'current'}`"
      body-class="subs-info-card-body"
      data-test-hook="downgrade-subscription-card"
    >
      <template #header>
        <div data-test-hook="downgrade-plan-header" class="plan-header">
          {{ isNewPlan ? subscriptionProduct.name : subscriptionProduct.subscriptionProductName }}
        </div>
      </template>
      <b-row class="align-items-center mb-2 mx-0">
        <b-col class="px-0">
          <b-badge
            v-if="isNewPlan"
            variant="primary"
            class="plan-badge"
            data-test-hook="downgrade-subscription-card-new-plan-badge"
            >{{ $t('xNewPlan') }}</b-badge
          >
          <b-badge
            v-else
            variant="light"
            class="border-primary text-primary plan-badge"
            data-test-hook="downgrade-subscription-card-current-plan-badge"
            >{{ $t('xCurrentPlan') }}</b-badge
          >
        </b-col>
        <b-col class="px-0 price">
          <span class="mb-0 pb-0" data-test-hook="downgrade-subscription-card-cost">
            <span class="price" style="font-size: 1.75rem;">{{
              (isNewPlan ? subscriptionProduct.cost : subscriptionProduct.subscriptionCost) | formatCurrency
            }}</span>
          </span>
          <span class="yearly ml-1">
            /{{ displayPlanCostCycle(isNewPlan ? subscriptionProduct.durationInMonths : subscriptionProduct.subscriptionDurationInMonths) }}
          </span>
        </b-col>
      </b-row>
      <div class="subscriptionCardText">
        <b-row>
          <b-col>
            <strong data-test-hook="existing-subscription-modal-premium-monitoring-max-products-text">
              {{
                getMaxProductText(isNewPlan ? subscriptionProduct.productId : subscriptionProduct.subscriptionProductId)
              }}
            </strong>
          </b-col>
        </b-row>
        <b-row v-for="(apparatus, index) in apparatusesToDowngrade" :key="index">
          <b-col class="mt-2">
            <div class="d-flex">
              <i class="fas fa-fw fa-check-circle check-icon mr-2" />
              <p>{{ apparatus.name }}</p>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </b-card-group>
</template>

<script>
import * as Constants from '@/constants'

export default {
  props: ['subscriptionProduct', 'apparatusesToDowngrade', 'isNewPlan'],
  methods: {
    displayPlanCostCycle(duration) {
      if (duration === 1) return this.$t('xMonth').toLowerCase()
      if (duration === 12) return this.$t('xYear').toLowerCase()
    },
    getMaxProductText(productId) {
      switch (productId) {
        case Constants.HomePremiumOneYearlyProductId:
        case Constants.HomePremiumOneMonthlyProductId:
          return this.$t('xPremiumMonitoringMaxProducts')
        case Constants.HomePremiumMultiHomeYearlyProductId:
        case Constants.HomePremiumMultiHomeMonthlyProductId:
          return this.$t('xPremiumMultiHomeMaxProducts')
        case Constants.SingleGeneratorMonthlyProductId:
        case Constants.SingleGeneratorYearlyProductId:
          return this.$t('xSingleGeneratorMaxProducts')
        case Constants.SingleFuelMonitorMonthlyProductId:
        case Constants.SingleFuelMonitorYearlyProductId:
          return this.$t('xSingleFuelMonitorMaxProducts')
        default:
          return ''
      }
    }
  }
}
</script>
<style lang="scss">
#subscription-downgrade-card {
  margin: 0 !important;

  .paid-subs-info-card {
    &.current {
      border: 2px solid var(--carbon-300) !important;

      .plan-header {
        background-color: var(--carbon-300);
      }
    }

    &.new {
      border: 2px solid var(--brand-400) !important;

      .plan-header {
        background-color: var(--brand-400) !important;
      }
    }
  }

  .price {
    text-align: center;
  }

  .plan-badge {
    &.border-primary {
      border: 2px solid;
    }

    &:not(.border-primary) {
      padding: 5px;
    }
  }

  .subs-info-card-body {
    padding: 0px 25px 25px !important;
  }

  .card-header {
    align-items: stretch;
    padding: 0;
    border-bottom: 0;
    height: 40px;
  }

  .card-title {
    margin-bottom: 0;
  }

  .yearly {
    font-size: 0.75rem;
  }

  .plan-header {
    text-align: center;
    padding: 5px 0px;
    font-size: 1.125em;
    line-height: 1.35;
    font-weight: 500;
  }

  .sub-radio-dot {
    font-size: 0.875rem !important;
  }

  .sub-premium-radio-duration {
    font-size: 16px !important;
    text-transform: lowercase !important;
  }

  .subscriptionCardText {
    font-size: 16px !important;
  }

  .btn-subscription-radio {
    color: var(--carbon-900);
    font-size: 30px;
    font-weight: bold;
    padding: 0.375rem 2rem;
    border-color: var(--brand-600);
    border-width: 2px;
    margin-bottom: 10px;
  }

  .btn-subscription-radio:not(:disabled):not(.disabled):hover {
    background-color: var(--orange-200);
  }

  .btn-subscription-radio:not(:disabled):not(.disabled):focus:active {
    box-shadow: 0px 0px 8px rgba(255, 107, 0, 0.25) !important;
    border-width: 2px;
  }

  .btn-subscription-radio.active {
    box-shadow: 0 0 0 0.2rem rgba(255, 107, 0, 0.25) !important;
  }

  i {
    font-size: 1.125em;
    color: var(--carbon-600);
  }

  .check-icon {
    color: var(--blue-700);
  }
}
</style>
